<template>
  <v-row justify="center">
    <!-- don't use v-model because it will try to edit dialog which is a prop -->
    <v-dialog :value="dialog" @input="close" max-width="600px">
      <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
        <v-card :loading="loading_dialog">
          <v-card-title>
            <span class="headline">Payment Breakdown</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider name="payee" rules="required"  v-slot="{ errors, valid }">
                      <v-text-field
                        v-model="payee"
                        label="Payee"
                        :error-messages="errors"
                        :success="valid"></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="amount" rules="required|currency"  v-slot="{ errors, valid }">
                      <v-text-field
                        prefix="$"
                        v-model="amount"
                        label="Amount"
                        :error-messages="errors"
                        :success="valid"></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small>You will be able to upload a W9 form after you enter the above information.</small>
            <template v-if="error != null">
              <br><span class="red--text">{{ error }}</span>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Close</v-btn>
            <v-btn color="blue darken-1" text @click="saveInfo" :disabled="invalid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'

export default {
  props: {
    item_id: Number,
    dialog: Boolean,
    loading_dialog: Boolean,
    vendor_id: Number,
    payment_breakdowns: Array,
    payment_amount: Number
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      payee: null,
      amount: null,
      error: null
    }
  },
  computed: {
    paymentBreakdownsSum() {
      const vm = this
      let sum = 0
      vm.payment_breakdowns.forEach(breakdown => {
        if(breakdown.hasOwnProperty('amount')) sum += breakdown.amount
      })
      return sum
    }
  },
  watch: {
    // autofills inputs with payment_breakdown info
    dialog: function() {
      if(this.dialog && this.item_id > 0) {
        const breakdown = this.payment_breakdowns.find(o => o.id == this.item_id)
        this.payee = breakdown.payee_manual
        this.amount = breakdown.amount
      }
      else {
        this.payee = null
        this.amount = null
      }
    }
  },
  methods: {
    close() {
      this.payee = null
      this.amount = null
      this.error = null
      this.$emit('closedialog')
    },
    saveInfo() {
      if(this.paymentBreakdownsSum + this.amount > this.payment_amount) {
        this.error = "Individual payment amount must be smaller or equal to the total payment amount."
        return
      }
      this.error = null

      const vm = this
      const putOpusApi = firebase.functions().httpsCallable('putOpusApi')

      const method = vm.item_id == 0 ? 'post' : 'put'
      let data = {
        Amount: vm.amount,
        Payee_Manual: vm.payee,
        ID_Vendor_Assignment: vm.$store.state.assignment,
        ID_Vendor: vm.vendor_id
      }
      if(vm.item_id != 0) { data.id = vm.item_id }

      vm.$emit('loadingdialog')
      putOpusApi({
        method: method,
        table: 'vendor_assignment_payment_breakdowns',
        params: data
      }).then(function() {
        vm.$emit('closedialog')
        vm.$emit('reloadtable')
      })
    }
  }
}
</script>